import {
  Signup,
  SignIn,
  Authorization,
  Forgetpassword,
  Logout,
  Verify_account_otp,
  Verify_signin_otp,
  Subusersignuop,
  Getsubsuser,
  ResendOTP,
} from "./login"

import {
  CanSignIn,
  CanLogout,
  CanVerifySigninOtp,
  CanResendOTP,
} from "./logincandidate"

import { GetProductPlans } from "./landingpage";

import {
  NuJobsSignup,
  NuJobsSignIn,
  NuJobsResendOTP,
  NuJobsVerifyAccountOtp,
  NuJobsVerifySignInOtp,
  NuJobsLogout,
} from "./nujobslogin"

export const actions = {
  Signup,
  SignIn,
  ResendOTP,
  Verify_account_otp,
  Verify_signin_otp,
  Subusersignuop,
  Getsubsuser, 
  Authorization,
  Forgetpassword,
  Logout,
  GetProductPlans,
}

export const actionsCandidates = {
  CanSignIn,
  CanResendOTP,
  CanVerifySigninOtp,
  CanLogout,
}

export const actionsNuJobs = {
  NuJobsSignup,
  NuJobsSignIn,
  NuJobsResendOTP,
  NuJobsVerifyAccountOtp,
  NuJobsVerifySignInOtp,
  NuJobsLogout,
}

